class MotoPromoProductCarousel extends HTMLElement {
  async connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    const track = this.querySelector('[data-moto-track]');
    const status = this.querySelector('[data-carousel-status]');
    const previous = this.querySelector('[data-moto-direction="prev"]');
    const next = this.querySelector('[data-moto-direction="next"]');
    const updateControls = () => {
      previous.disabled = track.scrollLeft < 2;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    };
    try {
      const response = await fetch(this.dataset.catalog);
      if (!response.ok) throw new Error('Catalog unavailable');
      const catalog = await response.json();
      const images = JSON.parse(this.querySelector('[data-carousel-images]').textContent);
      const fragment = document.createDocumentFragment();
      const displayModels = [...catalog.models].sort((a, b) => Number(Boolean(b.originalPrice)) - Number(Boolean(a.originalPrice)) || (b.originalPrice || b.regularPrice || 0) - (a.originalPrice || a.regularPrice || 0));
      for (const model of displayModels) {
        const card = document.createElement('article');
        card.className = 'moto-home-promo-product';
        card.dataset.model = model.id;
        const image = document.createElement('img');
        image.src = images[model.id];
        image.alt = model.title;
        image.width = 400;
        image.height = 400;
        image.loading = 'lazy';
        const body = document.createElement('div');
        body.className = 'moto-home-promo-product__body';
        const brand = document.createElement('p');
        brand.className = 'moto-home-promo-product__brand';
        brand.textContent = model.brand;
        const title = document.createElement('h4');
        title.textContent = model.title;
        const label = document.createElement('p');
        label.className = 'moto-home-promo-product__label';
        label.textContent = 'Elige tu talla';
        const sizes = document.createElement('div');
        sizes.className = 'moto-home-promo-product__sizes';
        for (const size of model.sizes) {
          const link = document.createElement('a');
          const url = new URL(this.dataset.link, location.origin);
          url.searchParams.set('modelo', model.id);
          url.searchParams.set('talla', size);
          url.hash = 'seleccion';
          link.href = url.href;
          link.textContent = size;
          link.dataset.size = size;
          link.setAttribute('aria-label', `Elegir ${model.title}, talla ${size}`);
          sizes.append(link);
        }
        body.append(brand, title, window.MotoPromoPrices.render(model, catalog), label, sizes);
        card.append(image, body);
        fragment.append(card);
      }
      track.replaceChildren(fragment);
      status.hidden = true;
      track.addEventListener('scroll', updateControls, { passive: true });
      this.resizeObserver = new ResizeObserver(updateControls);
      this.resizeObserver.observe(track);
      requestAnimationFrame(updateControls);
    } catch (error) {
      status.replaceChildren();
      const link = document.createElement('a');
      link.href = this.dataset.link;
      link.textContent = 'Ver los modelos y tallas de la promoción';
      status.append(link);
    }
  }
  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    this.initialized = false;
  }
}
if (!customElements.get('moto-promo-product-carousel')) customElements.define('moto-promo-product-carousel', MotoPromoProductCarousel);
